// Snackbar composable for displaying temporary messages to the user
// Provides a simple interface to show snackbar notifications with a message and color

export function useSnackbar() {
  // State to hold the snackbar message and visibility
  const snackbarState = useState("snackbarMessage");

  /**
   * Displays a snackbar with the given message and color
   * @param message - The message to display in the snackbar
   * @param color - The color of the snackbar (e.g., 'success', 'error')
   */
  const showSnackbar = (message: string, color: string) => {
    snackbarState.value = {
      message,
      snackbarColor: color,
      visible: true,
    };
  };

  return {
    showSnackbar,
  };
}
